import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  createPersistedState({
    paths: [
      'devise','auth','client',
    ],  // localStorageに保存したいstoreを入れる
  })(store);
};